import ListItemComponent from '../../../../stories/molecules/list-items'
import { listItemListViewVariantOptions } from '../../../../stories/molecules/list-items/constants'
import {
  LoadingContainer,
  ProjectMembersTabMembersContainer
} from '../../../styled-components'
import { isEmpty } from 'lodash'
import { projectMembersTabOptions } from '../../../constants'
import ProjectMembersEmptyList from '../project-member-empty-list'
import MemberItem from './member-item'
import { iconSizeOptions } from '../../../../stories/atoms/icons/icons-sizes'
import { SpinnerGrey } from '../../../../stories/atoms/icons/special'
import PropTypes from 'prop-types'

const MembersList = ({ members = [], isLoading = false }) => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
      </LoadingContainer>
    )
  }

  if (isEmpty(members)) {
    return (
      <ProjectMembersEmptyList variant={projectMembersTabOptions.MEMBERS} />
    )
  }

  return (
    <ProjectMembersTabMembersContainer>
      <ListItemComponent.Root
        listViewType={listItemListViewVariantOptions.TOGETHER}
        dividerFull={false}
        hideDivider
        style={{
          border: 'none'
        }}
      >
        {members.map((item) => {
          return <MemberItem key={item.userId} item={item} />
        })}
      </ListItemComponent.Root>
    </ProjectMembersTabMembersContainer>
  )
}

MembersList.propTypes = {
  members: PropTypes.array,
  isLoading: PropTypes.bool
}

export default MembersList
